export default __webpack_public_path__ + "static/media/goopter-promobot-screen-advertisment-promotions.bbd1d5d6.jpg";